import ClickWrapper from '@/components/ClickWrapper'
import { selectFiles } from '@/utils/file'
import { css } from '@emotion/react'
import { VideoIcon } from '@ruguoapp/jike-fe-icons'
import type { HTMLAttributes } from 'react'

export interface VideoAttachmentPickerProps
	extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
	onSelect?: (files: File[]) => void
	disabled?: boolean
}

export default function VideoAttachmentPicker({
	disabled,
	onSelect,
	...props
}: VideoAttachmentPickerProps) {
	return (
		<ClickWrapper
			css={css`
				display: flex;
			`}
			onClick={() => {
				selectFiles({
					multiple: true,
					accept: 'video/*',
				}).then((files) => {
					onSelect?.(files)
				})
			}}
		>
			<VideoIcon
				css={css`
					width: 20px;
					height: 20px;
					${disabled
						? css`
								cursor: not-allowed;
								color: var(--tint-icon-gray);
							`
						: 'color: var(--tint-jike-blue);'}
				`}
			/>
		</ClickWrapper>
	)
}
